import { useCallback, useMemo } from 'react';
import { Object3D } from 'three';

import { useSelection } from '@spazious/dollhouse-engine';
import { FNode, FNodeTypesEnum, getNodeFromObject } from '@spazious/dollhouse-fsetup';

export const useSelectedNodes = (selectOriginator = false) => {
  const { selected } = useSelection();

  const objectNodeReducer = useCallback(
    (acc: FNode[], object: Object3D): FNode[] => {
      const node = getNodeFromObject(object) as FNode | null;
      return node
        ? [
            ...acc,
            selectOriginator && node.type === FNodeTypesEnum.Furniture && node.originator
              ? node.originator
              : node,
          ]
        : acc;
    },
    [selectOriginator]
  );

  // Memoized the return value as if it is used in an useEffect it triggers infinite re-renders
  return useMemo(
    () => Array.from(new Set([...selected].reduce<FNode[]>(objectNodeReducer, [] as FNode[]))),
    [objectNodeReducer, selected]
  );
};
